import React from "react";
import { BackgroundImage, TeethLogo } from "../../Components";
import ahmedImg from "../../assets/Images/ahmed-ali.jpg"
import { IoMdMail } from "react-icons/io";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import allPaths from "../../Config/paths"

const OurTeam = (props) => {
    const { selectedLanguage } = props

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
        });
    };
    const history = useHistory()
    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.txt_our_team} text={selectedLanguage?.txt_we_make_beautiful_smiles_a_reality} mainClass='our-team-banner' />
            <TeethLogo heading={selectedLanguage?.txt_our_team} />
            <div className="team-container">
                <div onClick={handleScrollToTop} className="team-container-img-div">
                    <img src={ahmedImg} alt="" />
                </div>
                <div className="team-container-text-div">
                    <h2>{selectedLanguage?.txt_our_team_dr_name}</h2>
                    <span>{selectedLanguage?.txt_oral_surgery_and_medicine}
                    </span>
                    <h3>{selectedLanguage?.txt_we_are_proud_to_have_the_opportunity}</h3>
                    <p>{selectedLanguage?.txt_graduated_from_faculty_of_dentistry}
                    </p>
                    <button className="card-section-2-btn service-btn" onClick={() => history.push(allPaths?.CONTACT)}>{selectedLanguage?.send_a_message_button}</button>
                </div>
            </div>
            <div className="team-cards-main">
                <div>
                    <div className="team-card-div">
                        <div className="team-cards-heder-div-left">
                            <h2>{selectedLanguage?.txt_dr_one}</h2>
                            <span>{selectedLanguage?.txt_oral_surgery_and_medicine_dr_Dec}</span>
                        </div>
                        <div className="team-cards-heder-div-right">
                            <IoMdMail onClick={()=> history.push(allPaths?.CONTACT)} className="team-mail-icon" />
                        </div>
                    </div>
                    <div className="team-card-text-div">
                        <p>{selectedLanguage?.txt_First_dr_description_our_team}</p>
                        </div>
                </div>
                <div>
                    <div className="team-card-div">
                        <div className="team-cards-heder-div-left">
                            <h2>{selectedLanguage?.txt_second_dr}</h2>
                        </div>
                        <div className="team-cards-heder-div-right">
                            <IoMdMail onClick={()=> history.push(allPaths?.CONTACT)}  className="team-mail-icon" />
                        </div>
                    </div>
                    <div className="team-card-text-div">
                        <p>{selectedLanguage?.txt_second_dr_description}</p>
                        </div>
                </div>
                <div>
                    <div className="team-card-div">
                        <div className="team-cards-heder-div-left">
                            <h2>{selectedLanguage?.txt_third_dr}</h2>
                        </div>
                        <div className="team-cards-heder-div-right">
                            <IoMdMail onClick={()=> history.push(allPaths?.CONTACT)}  className="team-mail-icon" />
                        </div>
                    </div>
                <div className="team-card-text-div">
                        <p>{selectedLanguage?.txt_third_dr_description}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OurTeam